<template>
  <button
    class="algolia-facet__value"
    :class="{ [$class('active')]: facet.isRefined }"
    :tabindex="active ? 0 : -1"
    type="button"
  >
    <span
      v-if="isColour"
      class="algolia-facet__swatch"
      :class="{
        'algolia-facet__swatch--white': colourCode === '#ffffff',
        'algolia-facet__swatch--multi': colourCodeTwo,
      }"
      :style="`--swatch-colour: ${colourCode}; --swatch-colour-two: ${colourCodeTwo};`"
    >
      <span class="algolia-facet__swatch-inner" />
    </span>

    <span
      v-else
      class="algolia-facet__checkbox"
    >
      <icon-check />
    </span>

    <span
      v-if="!isColour"
      class="algolia-facet__value--key text-body-2xs"
      v-text="formatTitle(facet.value)"
    />

    <span
      class="algolia-facet__value--count text-body-2xs"
      v-text="`(${String(facet.count).padStart(2, 0)})`"
    />
  </button>
</template>

<script>

/**
 * Vue: Algolia facet value (algolia-facet-value)
 * -----------------------------------------------------------------------------
 * Individual value shown in mobile and desktop facets.
 *
 * @param {Boolean} isColour - Is it a colour facet?.
 * @param {Object} facet - Component facet.
 * @param {Boolean} active - Is parent refinement list open.
 *
 */
import IconCheck from '~icons/misc/check.svg'


export default {
  name: 'AlgoliaFacetValue',

  components: {
    IconCheck,
  },

  props: {
    isColour: {
      type: Boolean,
      default: false,
    },
    facet: {
      type: Object,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    /**
     * For colour swatches gets the colour code from the value.
     * @returns {String}
     */
    colourCode() {
      if (!this.isColour) {
        return false
      }

      if (!this.valueParts.length){
        return false
      }

      return this.valueParts[1]
    },

    /**
     * For colour swatches gets the colour code from the value.
     * @returns {String}
     */
     colourCodeTwo() {
      if (!this.isColour) {
        return false
      }

      if (this.valueParts.length <= 2) {
        return false
      }

      return this.valueParts[3]
    },

    valueParts(){
      if (!this.isColour) {
        return []
      }

      return this.facet?.value?.split('-')
    },
  },

  methods: {

    /**
     * Format title for keys that include tag values.
     * @param {String} value - Value key.
     * @returns {String}
     */
    formatTitle(value) {

      /**
       * Formats colour labels.
       */
      if (this.isColour) {

        if (this.valueParts.length && this.valueParts.length <= 2){
          return this.valueParts[0]
        } else if (this.valueParts.length > 2) {
          return `${this.valueParts[0]}/${this.valueParts[2]}`
        }
      }

      return value
    },
  },
}
</script>
